module.exports = __webpack_public_path__ + "static/media/vtex27.cea7b048.png";